<template>
  <div>
    <template v-if="loadingAccounts === true">
      <BSpinner label="Loading accounts..." />
      <br />
      Loading accounts...
    </template>
    <div v-else-if="acctUid === null">
      <slot name="empty">
        Your account has not been loaded yet. Please wait a moment and try
        again. Or, maybe you don't have any accounts. TODO add a component/modal
        that allows the user to select/create? an account.
      </slot>
    </div>
    <div v-else>
      <slot />
    </div>
  </div>
  <!-- TODO add a component/modal that allows the user to select/create? an account. -->
</template>

<script>
import {
  userSession as userSessNs,
  userAccount as userAcctNs,
} from "@/store/namespaces";
import { BSpinner } from "bootstrap-vue-next";

export default {
  name: "AccountContextWrapper",
  data() {
    return {};
  },
  components: {
    BSpinner,
  },
  computed: {
    acctUid() {
      return this.$store.getters[`${userAcctNs}/getSelectedAcctUid`];
    },
    accounts() {
      return this.$store.getters[`${userAcctNs}/getAccounts`] || [];
    },
    loadingAccounts() {
      return this.$store.getters[`${userAcctNs}/getLoadingAccounts`];
    },
    isAccountLoaded() {
      return this.acctUid !== null && this.acctUid !== undefined;
    },
  },
  async mounted() {
    await this.fetchUserAccounts();
  },
  methods: {
    async fetchUserAccounts() {
      try {
        if (this.isAccountLoaded && this.accounts.length > 0) {
          return;
        }

        const userInfo = await this.$store.dispatch(
          `${userSessNs}/getUserInfo`
        );
        const userId = userInfo?.id;

        if (!userId) {
          console.warn(
            "Cannot fetch user accounts because user id is undefined."
          );
          return;
        }

        await this.$store.dispatch(`${userAcctNs}/fetchUserAccounts`, userId);
      } catch (error) {
        console.error("Error fetching user accounts:", error);
      }
    },
  },
};
</script>
